import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { Stack } from '@mui/system';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector } from 'react-redux';
import { paths } from 'src/paths';
import { getAccessToken } from 'src/routes/AuthContext';

type Props = {};

function PreviewDocument(props: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { patients, patientDetails, episodeOfCare, details, physicianSign } = paths;
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  const goBackToEOC = () => {
    if (location.state?.source === 'physician-sign') {
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${physicianSign}`, {
        state: {
          episodeOfCareId: location?.state?.episodeOfCareId,
          getPatientId,
        },
      });
      return;
    }
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: location?.state?.episodeOfCareId,
        getPatientId,
      },
    });
  };

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
          onClick={goBackToEOC}
        >
          <Typography variant="subtitle1">
            Back to Episode Of Care Details -
            {` ${location?.state?.patientData?.lastName ?? ''} ${
              location?.state?.patientData?.firstName ?? ''
            }`}
          </Typography>
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          alignItems="center"
        >
          <Typography variant="h5">
            Preview Document - {location?.state?.document?.documentType}
          </Typography>
        </Stack>
      </Stack>
      <Box
        sx={{ height: '100%' }}
        p={3}
      >
        <iframe
          src={`${location?.state?.document?.pdfUrl}`}
          ref={updateIFrameRef}
          width={'100%'}
          height={'100%'}
          style={{ border: 'none' }}
        />
      </Box>
    </>
  );
}

export default PreviewDocument;
